import { axiosService } from './axios.service';

export interface UserStatusResponse {
  firebaseAuth: {
    exists: boolean;
    uid?: string;
  };
  firebaseRealtimeDb: {
    exists: boolean;
    data?: any;
  };
  zohoCRM: {
    exists: boolean;
    fullName?: string;
    platformId?: string;
  };
}

export class FirebaseAdminService {
  static async checkUserStatus(email: string): Promise<UserStatusResponse> {
    try {
      const response = await axiosService.get<UserStatusResponse>(`agent-actions/user-status/${encodeURIComponent(email)}`);
      return response;
    } catch (error) {
      console.error('Error checking user status:', error);
      // Return default structure with all services showing as not found
      return {
        firebaseAuth: { exists: false },
        firebaseRealtimeDb: { exists: false },
        zohoCRM: { exists: false }
      };
    }
  }
}